// extracted by mini-css-extract-plugin
export default {"playBtn":"PlayBtn_playBtn__X2avr","appear":"PlayBtn_appear__Q8R46"};